module.exports = __webpack_public_path__ + "teqbahn-assets/media/Dr. Benjamin Okanga.ae93b103.jpeg";